<div class="container">

  <app-header-dialog [iconName]="'account_balance'">
    {{ local_title }}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>account_balance</mat-icon>
          <div>Local</div>
        </ng-template>

        <div class='tab-content'>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.name.hasError('required')">
              O Nome é obrigatório
            </mat-error>
          </mat-form-field>


          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Cidade</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.city"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.city.hasError('required')">
              A Cidade é obrigatória.
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Estado</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.state"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.state.hasError('required')">
              O Estado é obrigatório.
            </mat-error>
          </mat-form-field>


          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Endereço</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.address"
              autocomplete="off">
            <mat-error *ngIf="entityForm.controls.address.hasError('required')">
              O Endereço é obrigatório.
            </mat-error>
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="this.isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>home</mat-icon>
          <div>Salas/Auditórios</div>
        </ng-template>

        <div class='tab-content'>
          <mat-table class="table-room" [dataSource]="dataSource" matSort matSortActive="date">

            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.name }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openRoomDialog(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-info' style='font-size:1.5em;'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <div style='width:60px;'>
                  <a mat-button (click)="openRoomDialog(null)">
                    <mat-icon color='primary'>add_circle_outline</mat-icon>
                  </a>
                </div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">

                <a mat-button (click)='deleteRoom(element)' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
                  </mat-icon>
                </a>

              </mat-cell>
            </ng-container>

            <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedRoomColumns">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedRoomColumns;">
            </mat-row>

          </mat-table>

        </div>

      </mat-tab>

    </mat-tab-group>

  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>